
import BasePageTemplate from "@/components/templates/BasePageTemplate.vue";
import {defineComponent, PropType} from "vue";
import {isNullish} from "@/utils/TypeUtil";
import scrollIntoView from "scroll-into-view-if-needed";

export interface Step {
  id: string;
  label: string;
  name: string;
  params?: Record<string, any>;
  editable: boolean;
  complete: boolean;
}

export interface StepGroup {
  name: null | string;
  stepLength: number;
}

interface ChunkedStep {
  index: number;
  step: Step;
}

interface Chunk {
  name: null | string;
  steps: ChunkedStep[];
}

export default defineComponent({
  name: "StepperPageTemplate",
  components: {BasePageTemplate},
  props: {
    step: {
      type: Number,
      required: true
    },
    /** Step の配列 */
    steps: {
      type: Array as PropType<Step[]>,
      required: true,
    },
    groups: {
      type: [Array, null] as PropType<null | StepGroup[]>,
      default: null,
      required: false,
    }
  },
  model: {
    prop: 'step',
    event: 'change-step'
  },
  computed: {
    stepOneOrigin: {
      get(): number {
        return this.step + 1;
      },
      set(value: number) {
        this.$emit("change-step", value - 1);
      }
    },
    chunkedSteps(): Chunk[] {
      if(isNullish(this.groups)) {
        return [{
          name: null,
          steps: this.steps.map((step, index) => ({index, step})),
        }];
      }

      const result: Chunk[] = [];
      let stepIndex = 0;
      for(const group of this.groups) {
        const chunk: ChunkedStep[] = [];
        for(let i = 0; i < group.stepLength; i++, stepIndex++) {
          chunk.push({
            index: stepIndex,
            step: this.steps[stepIndex],
          });
        }
        result.push({
          name: group.name,
          steps: chunk,
        });
      }
      if(stepIndex < this.steps.length) {
        const chunk: ChunkedStep[] = [];
        for (; stepIndex < this.steps.length; stepIndex++) {
          chunk.push({
            index: stepIndex,
            step: this.steps[stepIndex],
          });
        }
        result.push({
          name: null,
          steps: chunk,
        });
      }
      return result;
    },
    headerWidth(): number {
      return this.steps.length * 140;
    },
  },
  methods: {
    chunkHeaderWidth(chunk: Chunk): number {
      return chunk.steps.length * 140;
    },
  },
  watch: {
    step: {
      handler(step) {
        const stepperEl = window.document.querySelector(`.stepper-page-template-stepper-${(this as any)._uid}`);
        const stepEl = stepperEl?.querySelector(`.v-stepper__step[data-step-index="${step}"]`);
        if(stepEl) {
          scrollIntoView(stepEl, {
            behavior: 'smooth',
            boundary: stepperEl
          });
        }
      }
    }
  }
});
